// These are the most simple getters,
// they will navigate the path, return the data found
// or default to null for null/undefined

export const selectBalanceSheetErrorMessage = ($) => $.settings?.balanceSheet?.errorMessage;

export const selectBalanceSheetClientViewDataErrorMessage = ($) =>
  $.settings?.balanceSheet?.clientViewData?.errorMessage;

export const selectBalanceSheetClientViewData = ($) => $.settings?.balanceSheet?.clientViewData;
